export default "__VITE_ASSET__DWKoYSGY__"